import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { EndpointAccess } from '../models/access-catalog/endpoint-access';
import { RoleDescription } from '../models/access-catalog/role-description';

@Injectable({
  providedIn: 'root',
})
export class AccessCatalogProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/access-catalog`;
  constructor(private httpClient: HttpClient) {}

  getEndpoints(): Observable<ApiResponse<EndpointAccess[]>> {
    return this.httpClient.get<ApiResponse<EndpointAccess[]>>(`${this.baseUrl}/endpoints`);
  }

  getRoles(): Observable<ApiResponse<RoleDescription[]>> {
    return this.httpClient.get<ApiResponse<RoleDescription[]>>(`${this.baseUrl}/roles`);
  }
}
